import { Injectable } from '@angular/core';
import { BusinessNavEnvironmentService } from '../environment.service';
import { Environment } from '../environment';
import { Observable } from 'rxjs';
import { shareReplay, map } from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class HostService {
  public hostWithScheme$: Observable<string>;
  public host$: Observable<string>;

  constructor(private environmentService: BusinessNavEnvironmentService) {
    this.host$ = this.environmentService.environment$
      .pipe(
        map((env: Environment) => {
          switch (env) {
            case Environment.DEMO:
              return 'atlas-api-demo.apigateway.co';
            case Environment.PROD:
              return 'atlas-api-prod.apigateway.co';
          }
        }),
        shareReplay(1)
      );
    this.hostWithScheme$ = this.host$.pipe(
      map((host: string) => 'https://' + host),
      shareReplay(1)
    );
  }
}
